import styled from 'styled-components';

export const Button = styled.button`
  border: none;
  border-radius: 3px;
  background-color: #2196F3;
  padding: 8px 16px;
  min-width: 100px;
  font-size: 14px;
  font-weight: bold;
  color: white;
  cursor: pointer;
`
